import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

export type ButtonVariant =
    | 'primary'
    | 'secondary'
    | 'export'
    | 'reset'
    | 'approve'
    | 'reject'
    | 'review';

@Component({
    selector: 'app-button',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './button.component.html',
    styleUrls: ['./button.component.scss'],
})
export class ButtonComponent {
    @Input() variant: ButtonVariant = 'primary';
    @Input() icon?: string;
    @Input() label?: string;
    @Input() type: 'button' | 'submit' | 'reset' = 'button';
    @Input() disabled = false;
    @Input() title?: string;
}
